import {
  CloseCircleOutlined,
  CheckOutlined,
  DownOutlined,
  QuestionCircleOutlined,
  DoubleRightOutlined,
  EditOutlined,
} from '@ant-design/icons'
import {
  Row,
  Col,
  Tooltip,
  Checkbox,
  Button,
  Space,
  Divider,
  Tag,
  Empty,
  message,
  Input,
  Popover,
  Typography,
} from 'antd'
import { SSkuCard, STitle } from 'shj-components'
import styles from './index.module.less'
import { useEffect, useRef, useState } from 'react'
import _, { isArray, isEmpty } from 'lodash'
import { useUpdateEffect } from 'ahooks'
import { useNavigate, useParams } from 'react-router-dom'
import {
  DetailHouseInfoList,
  listProductSkuRelationSpuFormat,
  saveBudgetDtl,
} from '@/services/order'
// import ModifyStandard from '../../components/modifyStandard'
import { getUser } from '@/common/utils.ts'
import { batchGetForAuth, batchSaveOrUpdateForAuth } from '@/services/cache'
import KitDetailDialogV3 from '@/pages/orderServiceSpaceChoose/components/KitDetailDialogV3'
import ModifyStandard from '@/pages/orderServiceSpaceChoose/components/modifyStandard'
import SkuDynamicContent from '@/pages/orderServiceSpaceChoose/components/SkuDynamicContent'
import DeleteIcon from '@/assets/deleteIcon.png'
import Arrow from './assets/arrow.png'
import tagsMap from '../../utils'
import ComfirmModal from '../ConfirmModal'

const { TextArea } = Input
const { Text } = Typography
type IProps = {
  selectMaterialObj: any // 选中的材料
  currentSearchParams: any // 当前参数
  setFullLoading: (v: boolean) => void
  setDeleteMaterialObj: (v: any) => void
  budgetId: string
  type: string
  spaceId: string
  data: any
  setData: (v: any) => void
  btnInfo: any
  getGeneralList: () => void
}
export const RightConfigArea = (props: IProps) => {
  const {
    selectMaterialObj,
    currentSearchParams,
    setFullLoading,
    setDeleteMaterialObj,
    budgetId,
    type,
    spaceId, // 空间id
    data = [],
    setData = () => {},
    btnInfo,
    getGeneralList,
  } = props
  const params = useParams()
  const user = getUser()
  const navigate = useNavigate()
  // const budgetId = params.budgetId //报价id
  // const type = params.type //当前选材类型
  const cacheStr = `history_material_${user?.workNumber}_${budgetId}_${type}` //缓存key
  const refItemId = params.refItemId
  const [checkNumber, setCheckNumber] = useState<number>(0)
  const [spaceAllList, setSpaceAllList] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  // 是否收起
  const [expanded, setExpanded] = useState(false)
  const [collapseSpaceDetail, setCollapseSpaceDetail] = useState<any[]>([])
  // 备注、预算量计算式
  const [spaceDetailList, setSpaceDetailList] = useState<any[]>([])
  // 商品规格
  const [currentIndex, setCurrentIndex] = useState<number>(0) // 当前修改规格数组索引
  const [open, setOpen] = useState(false)
  const itemRef = useRef<HTMLDivElement>(null)
  const [showButton, setShowButton] = useState(false)
  const [record, setRecord] = useState<any>(null)

  // 初始化时 获取缓存数据
  useEffect(() => {
    getAllSpace()
    getCacheHistory()
  }, [])
  // const tagsMap = {
  //   NATIONAL_UPPLEMENT: 'nationalCss',
  // }
  // 获取所有空间
  const getAllSpace = async () => {
    const cacheData = await batchGetForAuth({ data: [cacheStr] })
    const spaceCheckedAll =
      cacheData && cacheData.length ? cacheData[cacheStr]?.value.spaceAllList : []
    DetailHouseInfoList({
      params: {
        quoteBudgetId: budgetId,
      },
    }).then(res => {
      const array: any = res
      if (!array.length) return
      array.forEach((item: any) => {
        //   // 添加属性
        item.checked = false
        if (spaceCheckedAll && spaceCheckedAll.length) {
          spaceCheckedAll.forEach(el => {
            if (el.id === item.id) {
              item.checked = el.checked
            }
          })
        }
      })
      // 过滤当前空间
      setSpaceAllList(array?.filter(el => el.id !== spaceId))
    })
  }
  // 更新当前选择数据
  useUpdateEffect(() => {
    console.log(selectMaterialObj, 'selectMaterialObj')
    console.log(data, 'data')
    if (isEmpty(selectMaterialObj)) {
      setData([])
      return
    }
    const array = _.cloneDeep(data)
    const obj = _.cloneDeep(selectMaterialObj)
    const newSpaceDetailList = _.cloneDeep(spaceDetailList)
    obj.spaceChecked =
      spaceAllList
        .filter(el => {
          if (el.checked && obj.budgetItemList?.find(elItem => elItem.id === el.id)) {
            return el.id
          }
        })
        .map(el => el.id) || []
    array.push(obj)
    array.forEach((item: any, index) => {
      // 默认勾选
      // item.spaceChecked = item?.budgetItemList[0]?.id ? [item.budgetItemList[0].id] : []
      item.spaceChecked = item?.budgetItemList?.find(el => el?.id === spaceId)?.id ? [spaceId] : []
      console.log(item, 'item123')
      // 构造数据
      item.list = item?.list?.map((el: any) => {
        el.calculateFunc = el?.budgetQtyValue
        el.calculate = el?.budgetQtyFormular
        el.elTag = el?.itemId
        return { ...el }
      })
      console.log(item, 'item123')

      newSpaceDetailList[index] = item.list
    })
    setSpaceDetailList(newSpaceDetailList)
    setData(array)
  }, [selectMaterialObj])
  // 更新加入选材数量
  useUpdateEffect(() => {
    console.log(data)
    let number = 0
    data.map(item => {
      if (item.checked) {
        number++
      }
    })
    setCheckNumber(number)
  }, [data])
  // 全局空间应用
  const onChangeSpaceAll = (e, item) => {
    const newData = _.cloneDeep(data)
    item.checked = e.target.checked
    let chooseNum = 0
    // 全选，应用全局
    newData.map(elItem => {
      // 实现空间全部应用 全选和全不选 即 全选的 空间只影响 该空间的勾选与否  不影响其他单独配的空间
      if (e.target.checked) {
        if (elItem.budgetItemList?.find(el => el.id === item.id)) {
          elItem.spaceChecked.push(item.id)
          elItem.spaceChecked = Array.from(new Set(elItem.spaceChecked))
          chooseNum += 1
        }
      } else {
        elItem.spaceChecked = elItem.spaceChecked.filter(el => el !== item.id)
      }
    })
    e.target.checked && message.info(`${chooseNum}个商品应用到${item?.showName}`)
    setData(newData)
  }
  // 单个空间应用
  const onChangeSpace = (checkedValues: string[], index?: any) => {
    const newData = _.cloneDeep(data)
    newData[index].spaceChecked = checkedValues
    // 处理默认值
    checkedValues.forEach((id: string) => {
      let spaceItem = newData[index].budgetItemList.find(el => el.id === id)
      if (spaceItem.displayQtyFormular) {
        changeCalculate(id, spaceItem.displayQtyFormular, index)
      }
    })
    setData(newData)
  }

  // 产品全选
  const onCheckAll = e => {
    const newData = _.cloneDeep(data)
    newData.map(elItem => {
      elItem.checked = e.target.checked
    })
    const number = e.target.checked ? data.length : 0
    setCheckNumber(number)
    setData(newData)
  }
  const handleCacheData = data => {
    if (data && data.length) {
      data = data.map((item: any) => {
        return item?.map((el: any) => {
          return {
            ...el,
            calculateFunc: Number(el.calculateFunc),
          }
        })
      })
    }
    return data || []
  }
  // 获取缓存
  const getCacheHistory = async () => {
    const cacheData = await batchGetForAuth({ data: [cacheStr] })
    if (cacheData && cacheData[cacheStr]) {
      let spaceDetailList = handleCacheData(cacheData[cacheStr]?.value?.spaceDetailList)
      setData(cacheData[cacheStr]?.value?.data || [])
      setSpaceDetailList(spaceDetailList)
    }
  }
  // 设置缓存
  const setCacheHistory = () => {
    let cacheData = {
      spaceAllList: spaceAllList,
      spaceDetailList: spaceDetailList,
      data: data,
    }
    batchSaveOrUpdateForAuth({
      data: [
        {
          key: cacheStr,
          value: cacheData,
        },
      ],
    }).then(res => {
      message.success(res.message || '保存成功')
    })
  }
  // 保存草稿
  const saveSpaceData = () => {
    setCacheHistory()
  }
  // 移除选材
  const deleteSpace = (record, index) => {
    setDeleteMaterialObj(record)
    const spaceList = _.cloneDeep(spaceDetailList)
    const collapseList = _.cloneDeep(collapseSpaceDetail)
    if (spaceList[index]) {
      spaceList.splice(index, 1)
    }
    if (typeof collapseList[index] === 'boolean') {
      collapseList.splice(index, 1)
    }
    setSpaceDetailList(spaceList)
    setCollapseSpaceDetail(collapseList)
    const array = _.cloneDeep(data)
    array.splice(index, 1)
    if (array.length === 0) {
      const list = spaceAllList
      list.map(el => {
        el.checked = false
      })
      setSpaceAllList(list)
    }
    setData(array)
  }

  // 提交数据  成功->删除缓存 跳转页面  失败->回显数据
  const submitData = () => {
    setLoading(true)
    setFullLoading(true)
    const submitData = postData(data)
    console.log(currentSearchParams, 'currentSearchParams')
    console.log(submitData, 'submitData')
    const unSubmitData = submitData.filter(el => !el.checked) // 未提交数据 需要回显
    const unSubmitSpaceDetailList: any = []
    const unSubmitCollapseList: any = []
    submitData.forEach((item: any, index: number) => {
      if (!item.checked) {
        unSubmitSpaceDetailList.push(spaceDetailList[index])
        unSubmitCollapseList.push(collapseSpaceDetail[index])
      }
    })
    saveBudgetDtl({
      data: submitData.filter(el => el.checked),
    })
      .then((res: any) => {
        console.log(res)
        if (res && res.length) {
          message.error('添加选材失败')
          let reviewData = res.concat(unSubmitData)
          console.log(reviewData, '提交失败回显数据')
          setData(reviewData)
        } else {
          message.success('添加选材成功')
          // 提交成功移除已提交物料 清除缓存
          setData(unSubmitData)
          setSpaceDetailList([...unSubmitSpaceDetailList])
          setCollapseSpaceDetail([...unSubmitCollapseList])
          // 清空缓存
          batchSaveOrUpdateForAuth({
            data: [
              {
                key: cacheStr,
                value: {},
              },
            ],
          })
          // 清除勾选状态
          const list = spaceAllList
          list.map(el => {
            el.checked = false
          })
          setSpaceAllList(list)
        }
      })
      .catch(() => {
        const chooseData = _.cloneDeep(data)
        const newChooseData = chooseData.map(item => ({
          ...item,
          errMessage: '',
        }))
        setData(newChooseData)
      })
      .finally(() => {
        setLoading(false)
        setFullLoading(false)
      })
  }
  // 数据处理
  const postData = data => {
    console.log(currentSearchParams, 'currentSearchParams')

    data.map((item: any, index: number) => {
      // // 缓存数据可能会自身携带
      item.quoteBudgetId = budgetId
      item.refItemId = refItemId // 当前项目id
      item.type = type // 为通项传值
      // item.addType = currentSearchParams.sourceType || null
      // 空间明细字段处理
      if (item.spaceChecked && item.spaceChecked.length) {
        const array: any = []
        item.spaceChecked.forEach((el: any) => {
          // 获取空间的信息
          // 存在只有空间没有预算量计算式的情况
          if (spaceDetailList && spaceDetailList.length) {
            const obj = spaceDetailList[index]?.find(item => item.elTag === el)
            array.push({
              itemId: obj ? obj.elTag : el, // 空间标识id,
              remark: obj ? obj.remark : '',
              budgetQtyValue:
                obj &&
                (obj.calculateFunc || obj.calculateFunc === 0) &&
                typeof obj.calculateFunc === 'number'
                  ? obj.calculateFunc
                  : '',
              budgetQtyFormular: obj ? obj.calculate : '',
              elTag: obj ? obj.elTag : '', // 空间标识id
            })
          } else {
            array.push({
              itemId: el, // 空间标识id,
              remark: '',
              budgetQtyValue: '',
              budgetQtyFormular: '',
              elTag: el, // 空间标识id
            })
          }
        })

        if (type === 'SUB') {
          array.forEach((el: any) => {
            el.reduceSourceBudgetDtlId = item.referenceId
          })
        }
        item.list = array
      }
      if (
        (type === 'ADD' && !item.budgetItemList?.length) ||
        (type === 'SUB' && !item.budgetItemList?.length) ||
        (type === 'PROJECT' && !item.budgetItemList?.length)
      ) {
        // 无空间信息 但有一条预算量计算式
        const array: any = []
        array.push({
          itemId: refItemId,
          remark: item.remark || '',
          budgetQtyValue: item.calculateFunc,
          budgetQtyFormular: item.calculate || '',
        })
        item.list = array
      }
      item.dynaOptions = item.dynaOptions ? item.dynaOptions : item.productSku?.argMap
      // 处理产品明细
      if (item.packDtlList?.length) {
        item.packDtlList = item.packDtlList.filter(el => el.selectSkuId&& el.checked)
      }
      // 每种类型特殊字段处理
      switch (item.type) {
        case 'ACTIVITY':
          item.activityId = item.activity?.id
          item.activityProductId = item.activityProduct?.id
          item.refItemId = btnInfo?.id // 当前项目id
          delete item.generalId
          break
        case 'UP_DOWN':
          // 升降级 需要传参通项Id
          item.refItemId = btnInfo?.id // 当前项目id
          // item.generalId = currentSearchParams.generalId // 通项id
          break
        case 'SUB':
          item.reduceSourceBudgetDtlId = item.referenceId
          item.refItemId = btnInfo?.id // 当前项目id
          item.generalId = item.generalItemManageId
          break
        case 'ADD':
          item.refItemId = btnInfo?.id // 当前项目id
          item.generalId = item.generalItemManageId
          break
        default:
          break
      }
    })
    console.log(data, 'data')
    return data
  }

  const handleLongDesc = data => {
    // 子产品有且只有一个为来源物料 工艺说明为该子产品的sku的工艺说明
    let materialList = data?.filter(
      (item: any) => item?.product?.sourceType === 'MATERIAL' && item?.checked
    )
    if (materialList.length === 1) {
      let skuInfo = materialList[0]?.skuList?.find(
        (el: any) => el.id === materialList[0]?.selectSkuId
      )
      return skuInfo?.longDesc
    } else {
      return ''
    }
  }

  const changeCalculate = (elTag: string, val: string, index: number) => {
    const list = _.cloneDeep(spaceDetailList) || []
    let funcRes: any = ''
    try {
      const func = new Function(`return ${val}`)
      funcRes = func()
    } catch (err) {
      funcRes = false
    }
    funcRes = typeof funcRes === 'number' ? Number(funcRes.toFixed(4)) : funcRes
    if (list[index]) {
      const obj = list[index]?.find(item => item.elTag === elTag)
      if (obj) {
        obj.calculate = val
        obj.calculateFunc = funcRes
      } else {
        list[index].push({
          elTag,
          calculate: val,
          calculateFunc: funcRes,
        })
      }
    } else {
      list[index] = [
        {
          elTag,
          calculate: val,
          calculateFunc: funcRes,
        },
      ]
    }
    setSpaceDetailList(list)
  }

  // 增项-预算量计算式计算
  const onChangeCalculateAdd = (index: number, val: string) => {
    if (val) {
      let funcRes: any = ''
      try {
        const func = new Function(`return ${val}`)
        funcRes = func()
      } catch (err) {
        funcRes = false
      }
      funcRes = typeof funcRes === 'number' ? Number(funcRes.toFixed(4)) : funcRes
      const newData = _.cloneDeep(data)
      newData[index].calculate = val
      newData[index].calculateFunc = funcRes
      setData(newData)
    }
  }

  const changeRemark = (elTag: string, val: string, index: number) => {
    const list = _.cloneDeep(spaceDetailList) || []
    if (list[index]) {
      const obj = list[index]?.find(item => item.elTag === elTag)
      if (obj) {
        obj.remark = val
      } else {
        list[index].push({
          elTag,
          remark: val,
        })
      }
    } else {
      list[index] = [
        {
          elTag,
          remark: val,
        },
      ]
    }
    setSpaceDetailList(list)
  }
  // 空间选择弹出层
  const spaceContent = (index: number) => {
    const spaceChange = (id: string, index: number, error: string) => {
      console.log(id)
      if (id === spaceId) {
        return
      }
      if (error) {
        return
      }
      let list: any = _.cloneDeep(data[index].spaceChecked)
      if (data[index].spaceChecked.includes(id)) {
        list = data[index].spaceChecked.filter(itemId => itemId !== id)
      } else {
        list.push(id)
      }
      onChangeSpace(list, index)
    }
    return (
      <div style={{ maxHeight: '400px', overflowY: 'scroll' }}>
        {data?.[index].budgetItemList?.map((item: any, idx: number) => (
          <>
            <div
              onClick={() => {
                spaceChange(item.id, index, item.errMessage)
              }}
              key={idx}
              style={{
                display: 'flex',
                color: item.errMessage ? 'gray' : '#000',
                justifyContent: 'space-between',
                marginTop: '6px',
                marginBottom: '6px',
                paddingLeft: '8px',
                paddingRight: data[index].spaceChecked?.includes(item.id) ? '8px' : '30px',
                cursor: 'pointer',
                backgroundColor: data[index].spaceChecked?.includes(item.id)
                  ? 'rgb(229, 245, 243)'
                  : '#fff',
              }}
            >
              {item?.showName}
              {data[index].spaceChecked?.includes(item.id) && (
                <span style={{ marginLeft: '8px', color: 'rgb(19, 101, 91)' }}>
                  <CheckOutlined />
                </span>
              )}
            </div>
          </>
        ))}
      </div>
    )
  }

  const removeSingeSpace = (index: number, elTag) => {
    const newData = _.cloneDeep(data)
    const newSpaceList = _.cloneDeep(spaceAllList)
    newData[index].spaceChecked = newData[index].spaceChecked.filter(el => el != elTag)
    // 判断如果所有物料都删除该空间，则全选空间里也要去掉
    const existingElTags = new Set()
    newData.forEach(product => {
      if (product.spaceChecked) {
        product.spaceChecked.forEach(space => {
          if (space) {
            existingElTags.add(space)
          }
        })
      }
    })
    // 然后更新 newSpaceList
    newSpaceList.forEach(space => {
      if (!existingElTags.has(space?.id)) {
        space.checked = false
      }
    })
    setData(newData)
    setSpaceAllList(newSpaceList)
  }

  const handlePrice = (item: any) => {
    let value =
      item.changeLevelCustomerPrice ??
      item.budgetDtlSkuSalePrice ??
      item.productSkuSalePrice ??
      item.saleCustPrice

    return value || value === 0 ? '￥' + value : ''
  }
  const showNationalTagRender = (item: any) => {
    if (item.packDtlList?.length > 0) {
      // 组合产品需判断除了施工项外是否全是国补 判断是否除了施工项都是国补 是则显示 国补标签
      let proList = item.packDtlList
        ?.filter(item => item?.product?.sourceType !== 'CONSTRUCTION')
        ?.filter(item => item.required || (!item.required && item.checked))
      let allNational = false
      if (proList?.length) {
        allNational = proList?.every((item: any) => {
          if (item.selectSkuId) {
            return item?.skuList?.find((sku: any) => sku.id === item.selectSkuId)?.showTags
          }
          return false
        })
      }
      if (allNational) {
        return (
          <div
            className={'normal_tag_style'}
            style={{
              color: tagsMap.NATIONAL_UPPLEMENT?.color,
              backgroundColor: tagsMap.NATIONAL_UPPLEMENT?.bgColor,
              marginRight: '8px',
            }}
          >
            <Tooltip placement="top" arrow={false} title={'国补'}>
              国补
            </Tooltip>
          </div>
        )
      }
    } else {
      let showTags = item?.productSpu?.skuList?.find(
        (sku: any) => sku.id === item.productSkuId
      )?.showTags
      if (showTags && isArray(showTags)) {
        return showTags?.map((tag: any) => {
          return (
            <div
              key={tag.tagCode}
              className={'normal_tag_style'}
              style={{
                color: tagsMap[tag.tagCode]?.color,
                backgroundColor: tagsMap[tag.tagCode]?.bgColor,
                marginRight: '8px',
                float: 'left',
              }}
            >
              <Tooltip title={tag.tagName}>{tag.tagName}</Tooltip>
            </div>
          )
        })
      } else {
        return <></>
      }
    }
  }
  const showProdCateTagRender = (tagName: any) => {
    if (tagName) {
      let strArray = tagName?.split('/')
      let str = strArray[strArray.length - 1]
      if (str) {
        return (
          <div
            className={'normal_tag_style'}
            style={{
              color: tagsMap.PROCATENAME?.color,
              backgroundColor: tagsMap.PROCATENAME?.bgColor,
              marginRight: '8px',
              float: 'left',
            }}
          >
            <Tooltip placement="top" arrow={false} title={str}>
              {str}
            </Tooltip>
          </div>
        )
      }
    }
  }
  useEffect(() => {
    const checkOverflow = () => {
      if (itemRef.current && itemRef.current) {
        // 检查内容高度是否超过容器高度
        console.log(itemRef.current.scrollHeight)

        const isOverflowing = itemRef.current.scrollHeight > 48
        setShowButton(isOverflowing)
      }
    }

    checkOverflow()
    window.addEventListener('resize', checkOverflow)
    return () => {
      window.removeEventListener('resize', checkOverflow)
    }
  }, [data, spaceAllList])

  const clickToModify = (record, index) => {
    console.log(record)
    setCurrentIndex(index)
    // if (multipleOpen) {
    //   // 批量设置，按照原逻辑处理
    //   clickToSelect(record)
    //   return
    // }
    // record.checked = true // 选到右侧默认勾选
    // record.spaceChecked = [] // 造数据 空间应用
    // record.generalId = type === 'ADD' || type === 'PROJECT' ? '' : generalId
    // record.calculate = ''
    // record.type = type
    setRecord(record)
    // // 如果套件明细数据，过滤调不显示的数据
    // if (record.productSpu?.combinationInfo?.length > 1) {
    //   record.productSpu.combinationInfo = record.productSpu?.combinationInfo.filter(
    //     item => item.allowView
    //   )
    //   // 打开套件明细弹窗
    //   setOpen(true)
    //   return
    // }
    setOpen(true)
    // }
  }
  const reConfirm = record => {
    console.log(record)
    // let longDesc = ''
    // if (combinationInfoDetail && combinationInfoDetail.length) {
    //   longDesc = handleLongDesc(combinationInfoDetail)
    // }
    const newData = _.cloneDeep(data)
    // newData[currentIndex].packDtlList = combinationInfoDetail
    // newData[currentIndex].productSkuSalePrice =
    //   combinationPrice || combinationPrice === 0
    //     ? combinationPrice
    //     : newData[currentIndex].productSkuSalePrice
    newData[currentIndex] = record

    setData(newData)
  }
  return (
    <div className={styles.baseBox}>
      <div className={styles.toolHead}>
        <STitle title={'批量设置空间'} />
      </div>
      {spaceAllList && spaceAllList.length > 0 && (
        <Row align="middle" justify="space-between" className={styles.topToolBar}>
          <Col
            span={21}
            style={{
              height: 'fit-content',
              maxHeight: !expanded ? '48px' : 'fit-content',
              overflow: 'hidden',
              display: 'flex',
              flexWrap: 'wrap',
              gap: '16px 8px',
            }}
            ref={itemRef}
          >
            {spaceAllList.map(item => {
              return (
                <Checkbox
                  disabled={data.length === 0}
                  key={item.id}
                  checked={item.checked}
                  onChange={(e: any) => onChangeSpaceAll(e, item)}
                  style={{ fontSize: '12px', lineHeight: '16px', height: '16px' }}
                >
                  {item.showName} {item.description ? `【${item.description}】` : ''}
                </Checkbox>
              )
            })}
          </Col>
          {showButton ? (
            <Col
              span={3}
              style={{
                textAlign: 'right',
                display: 'flex',
                alignItems: 'flex-end',
                height: !expanded ? '48px' : 'auto',
                justifyContent: 'flex-end',
              }}
            >
              <div onClick={() => setExpanded(!expanded)}>
                {expanded ? (
                  <>
                    <div className={styles.expandSpace}>
                      收起
                      <img
                        style={{
                          height: '12px',
                          width: '12px',
                          marginLeft: '4px',
                          rotate: '180deg',
                        }}
                        src={Arrow}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div className={styles.expandSpace}>
                      更多
                      <img
                        style={{ height: '12px', width: '12px', marginLeft: '4px' }}
                        src={Arrow}
                      />
                    </div>
                  </>
                )}
              </div>
            </Col>
          ) : null}
        </Row>
      )}

      <Row
        style={{
          padding: '0 15px',
          marginTop: '16px',
          display: 'flex',
          alignItems: 'center',
          height: '40px',
          backgroundColor: '#F7F8FA',
          borderBottom: '1px solid #DFE1E5',
        }}
      >
        <Col span={1}>
          <Checkbox
            disabled={data.length === 0}
            onClick={e => onCheckAll(e)}
            checked={data?.length ? data.every(el => el.checked) : false}
          ></Checkbox>
        </Col>
        <Col span={23} style={{ paddingLeft: '8px' }}>
          商品
        </Col>
      </Row>
      {/* 单个空间选择 */}
      <Space
        direction="vertical"
        size="small"
        split={<Divider style={{ margin: '0px' }} />}
        style={{
          width: '100%',
          flex: 1,
          overflowY: 'scroll',
          padding: '0 15px',
          paddingBottom: '20px',
          marginBottom: '40px',
          boxSizing: 'border-box',
        }}
      >
        {data.map((item, index) => {
          return (
            <div style={{ padding: '10px 0px' }} key={item.id + index} className={styles.item_box}>
              <Row>
                <Col span={1} style={{ display: 'flex' }}>
                  {/* 勾选框 */}
                  <Checkbox
                    disabled={item.errMessage}
                    checked={item.checked}
                    defaultChecked={item.checked}
                    onChange={e => {
                      item.checked = e.target.checked
                      setCheckNumber(data.filter(item => item.checked).length)
                    }}
                  ></Checkbox>
                </Col>
                <Col
                  span={23}
                  style={{ position: 'relative', paddingLeft: '8px' }}
                  // onMouseEnter={() => setIsHovered(true)}
                  // onMouseLeave={() => setIsHovered(false)}
                >
                  {/* 产品信息 */}
                  {/* 减项通项时只显示名字 */}
                  {item.onlyShowTitle && (
                    <div>
                      <div style={{ marginBottom: '10px' }}>{item.referenceName}</div>
                      {(item?.productSpu?.longDesc || item?.longDesc) && (
                        <p className={styles.skuCard_longDesc}>
                          <span>工艺说明：</span>
                          <Tooltip
                            title={item?.longDesc || item?.productSpu?.longDesc}
                            placement="topLeft"
                            // overlayStyle={{ maxWidth: '600px' }}
                            autoAdjustOverflow
                          >
                            <span>{item?.longDesc || item?.productSpu?.longDesc}</span>
                          </Tooltip>
                        </p>
                      )}
                      <div style={{ fontSize: '24px', color: 'rgba(235, 55, 35, 1)' }}>
                        {item.saleCustPrice || item.saleCustPrice === 0
                          ? '￥' + item.saleCustPrice
                          : ''}
                      </div>
                    </div>
                  )}
                  {!item.onlyShowTitle && (
                    <SSkuCard
                      width={`calc(100% - 8px)`}
                      url={item.productSkuPrimaryImage || item?.productSku?.mainPicUrl}
                      urlList={item?.productSku?.imageUrls}
                      desc={
                        <>
                          <p className={styles.skuCard_skuId}>
                            SKU: {item.productSkuId || item.referenceId}
                          </p>
                          {(item?.productSpu?.longDesc || item?.longDesc) && (
                            <p className={styles.skuCard_longDesc}>
                              <span>工艺说明：</span>
                              <Tooltip
                                title={item?.longDesc || item?.productSpu?.longDesc}
                                placement="topLeft"
                                // overlayStyle={{ maxWidth: '600px' }}
                                autoAdjustOverflow
                              >
                                <span>{item?.longDesc || item?.productSpu?.longDesc}</span>
                              </Tooltip>
                            </p>
                          )}
                        </>
                      }
                      operation={() => {
                        return <div className={styles.skuCard_price}>{handlePrice(item)}</div>
                      }}
                      title={
                        <div className={styles.skuCard_title}>
                          {showNationalTagRender(item)}
                          {showProdCateTagRender(item?.productSpu?.prodCateName)}
                          <span className={styles.skuCard_title_span}>
                            {item.productSkuName || item.referenceName}
                          </span>
                        </div>
                      }
                      imgFilter={
                        item?.errMessage ? (
                          <div dangerouslySetInnerHTML={{ __html: item?.errMessage }} />
                        ) : undefined
                      }
                      disabled={item.errMessage}
                    ></SSkuCard>
                  )}
                  {((item?.productSpu?.skuSize > 0 &&
                    !isEmpty(item?.productSpu?.skuList[0]?.argMap)) ||
                    item?.skuDynamicVoList?.length > 0 ||
                    item?.productSpu?.combinationInfo?.length > 1) && (
                    <div
                      style={{
                        display: 'flex',
                        position: 'absolute',
                        alignItems: 'center',
                        justifyContent: 'center',
                        right: '36px',
                        height: '32px',
                        width: '32px',
                        backgroundColor: '#fff',
                        border: '1px solid #0064FF',
                        borderRadius: '6px',
                        boxSizing: 'border-box',
                        top: '50%',
                        marginTop: '-16px',
                      }}
                      className={styles.delete_box}
                    >
                      <Tooltip title="修改规格" placement="top" arrow={false}>
                        <EditOutlined
                          onClick={() => clickToModify(item, index)}
                          style={{ color: '#0053cf', fontSize: '16px', cursor: 'pointer' }}
                        />
                      </Tooltip>
                    </div>
                  )}

                  <div
                    style={{
                      display: 'flex',
                      position: 'absolute',
                      alignItems: 'center',
                      justifyContent: 'center',
                      right: '0px',
                      height: '32px',
                      width: '32px',
                      backgroundColor: '#fff',
                      border: '1px solid #EB3723',
                      borderRadius: '6px',
                      boxSizing: 'border-box',
                      top: '50%',
                      marginTop: '-16px',
                    }}
                    className={styles.delete_box}
                  >
                    <Tooltip title="移除" placement="top" arrow={false}>
                      <img
                        src={DeleteIcon}
                        style={{ cursor: 'pointer', width: '16px', height: '16px' }}
                        onClick={() => deleteSpace(item, index)}
                        alt=""
                      />
                    </Tooltip>
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: '10px', paddingLeft: '20px' }}>
                {data[index].budgetItemList && data[index].budgetItemList?.length !== 0 && (
                  <Col span={7} style={{ height: '24px' }}>
                    {/* 空间配置 */}
                    <Popover content={() => spaceContent(index)} placement={'bottom'}>
                      <Button
                        disabled={item.errMessage}
                        size="small"
                        type="link"
                        style={{ gap: 0, color: '#575859', fontSize: '12px', fontWeight: 500 }}
                      >
                        应用空间（{data[index].spaceChecked?.length || 0}/
                        {data[index].budgetItemList?.length || 0}）
                        <DownOutlined />
                      </Button>
                    </Popover>
                  </Col>
                )}
                {data[index].spaceChecked && data[index].spaceChecked.length !== 0 && (
                  <>
                    <Col
                      style={{
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        color: '#575859',
                        fontSize: '12px',
                        fontWeight: 500,
                      }}
                      span={7}
                    >
                      <div
                        style={{
                          height: '100%',
                          display: 'flex',
                          alignItems: 'center',
                          color: 'red',
                        }}
                      >
                        *
                      </div>
                      预算量计算式
                    </Col>
                    <Col
                      style={{
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        color: '#575859',
                        fontSize: '12px',
                        fontWeight: 500,
                      }}
                      span={3}
                    >
                      预算量
                    </Col>
                    <Col
                      style={{
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        color: '#575859',
                        fontSize: '12px',
                        fontWeight: 500,
                      }}
                      span={6}
                    >
                      备注
                    </Col>
                  </>
                )}
              </Row>
              {/* 展开的内容 */}
              {!collapseSpaceDetail[index] &&
                data[index].spaceChecked &&
                data[index].spaceChecked.map((elTag, elTagIndex) => {
                  if (data[index].budgetItemList?.find(el => el.id == elTag)) {
                    return (
                      <Row style={{ marginTop: 10, marginBottom: 12 }}>
                        <Col
                          span={7}
                          style={{
                            lineHeight: '18px',
                            display: 'flex',
                            alignItems: 'center',
                            wordBreak: 'break-all',
                            color: '#2D2D2E',
                            fontSize: '12px',
                            fontWeight: 500,
                          }}
                        >
                          <CloseCircleOutlined
                            style={{
                              marginLeft: 8,
                              marginRight: 10,
                              visibility: elTag !== spaceId ? 'visible' : 'hidden',
                            }}
                            onClick={() => {
                              removeSingeSpace(index, elTag)
                            }}
                          />

                          <Text
                            style={{
                              color: '#2D2D2E',
                              fontSize: '12px',
                              fontWeight: 500,
                            }}
                            ellipsis={{
                              tooltip: data[index].budgetItemList?.find(el => el.id == elTag)
                                ?.showName,
                            }}
                          >
                            {data[index].budgetItemList?.find(el => el.id == elTag)?.showName}
                          </Text>
                        </Col>
                        {/**
                         * 预算量计算式
                         */}
                        <Col
                          span={7}
                          style={{ display: 'flex', alignItems: 'center', marginLeft: '20px' }}
                        >
                          <Input
                            disabled={
                              (!data[index].updateBudgetQtyFormularFlag && type === 'GENERAL') ||
                              item.errMessage
                            }
                            value={
                              spaceDetailList[index]?.find(el => el.elTag == elTag)?.calculate ||
                              data[index].list?.find(el => el.itemId == elTag)?.budgetQtyFormular ||
                              ''
                            }
                            onChange={e => changeCalculate(elTag, e?.target?.value, index)}
                            style={{ width: '85%', height: '24px', borderRadius: '3px' }}
                          ></Input>
                          {typeof spaceDetailList[index]?.find(el => el.elTag == elTag)
                            ?.calculateFunc === 'number' ? null : spaceDetailList[index]?.find(
                              el => el.elTag == elTag
                            )?.calculateFunc === false ? (
                            <span style={{ marginLeft: 4, color: 'red' }}>!</span>
                          ) : null}
                        </Col>
                        <Col span={3} style={{ marginLeft: '-10px' }}>
                          <Input
                            disabled={true}
                            value={
                              (typeof spaceDetailList[index]?.find(el => el.elTag == elTag)
                                ?.calculateFunc === 'number'
                                ? spaceDetailList[index]?.find(el => el.elTag == elTag)
                                    ?.calculateFunc
                                : '') ||
                              data[index].list?.find(el => el.itemId == elTag)?.budgetQtyValue
                            }
                            style={{ width: '80%', height: '24px', borderRadius: '3px' }}
                          ></Input>
                        </Col>
                        {/**
                         * 备注
                         */}
                        <Col
                          span={6}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            height: '24px',
                            marginLeft: '-4px',
                          }}
                        >
                          <Input
                            value={
                              spaceDetailList[index]?.find(el => el.elTag == elTag)?.remark || ''
                            }
                            style={{ borderRadius: '3px', height: '24px' }}
                            onChange={e => changeRemark(elTag, e?.target?.value, index)}
                            autoSize={{ minRows: 1, maxRows: 3 }}
                            maxLength={255}
                            showCount={false}
                            disabled={item.errMessage}
                          />
                        </Col>
                      </Row>
                    )
                  }
                })}
              {/* 新增增项 等没有空间也要显示预算量计算式 */}
              {!data[index].budgetItemList?.length && !data[index].spaceChecked?.length && (
                <>
                  <Row>
                    <Col style={{ height: '24px', display: 'flex', alignItems: 'center' }} span={6}>
                      预算量计算式
                    </Col>
                    <Col style={{ height: '24px', display: 'flex', alignItems: 'center' }} span={8}>
                      备注
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 10, marginBottom: 24 }}>
                    {/**
                     * 预算量计算式
                     */}
                    <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
                      <Input
                        onChange={e => {
                          onChangeCalculateAdd(index, e.target.value)
                        }}
                        value={data[index]?.calculate || ''}
                        style={{ width: '65%' }}
                        disabled={item.errMessage}
                      ></Input>

                      <span style={{ marginLeft: 4 }}>
                        {item.calculateFunc === false ? (
                          <span style={{ marginLeft: 4, color: 'red' }}>!</span>
                        ) : (
                          item.calculateFunc
                        )}
                      </span>
                    </Col>
                    {/**
                     * 备注
                     */}
                    <Col span={11} style={{ display: 'flex', alignItems: 'center' }}>
                      <TextArea
                        value={data[index]?.remark || ''}
                        onChange={e => {
                          const newData = _.cloneDeep(data)
                          newData[index].remark = e.target.value
                          setData(newData)
                        }}
                        placeholder="请输入备注"
                        autoSize={{ minRows: 1, maxRows: 3 }}
                        maxLength={255}
                        showCount
                        disabled={item.errMessage}
                      />
                    </Col>
                  </Row>
                </>
              )}
            </div>
          )
        })}
      </Space>
      {/* 暂无数据占位 */}
      {data.length === 0 && (
        <div className={styles.emptyBox}>
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            style={{
              height: '100%',
              margin: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          />
        </div>
      )}
      {/* 底部提交区域 */}
      <Row align={'middle'} justify={'space-between'} className={styles.bottomToolBar}>
        <Col span={8} style={{ display: 'flex', alignItems: 'baseline' }}>
          <Checkbox
            disabled={data.length === 0}
            onClick={e => onCheckAll(e)}
            checked={data?.length ? data.every(el => el.checked) : false}
          >
            全选
          </Checkbox>
          <span>已选 {checkNumber} 个</span>
        </Col>
        <Col span={16} style={{ textAlign: 'right' }}>
          <Button
            loading={loading}
            type="primary"
            disabled={data.filter(item => item.checked).length === 0}
            onClick={submitData}
            style={{ marginLeft: '10px' }}
          >
            确认设置
          </Button>
        </Col>
      </Row>
      {open && (
        <ComfirmModal
          open={open}
          setOpen={setOpen}
          record={record}
          type={type}
          budgetId={budgetId}
          spaceId={spaceId}
          generalId={record.generalId}
          btnInfo={btnInfo}
          getGeneralList={getGeneralList}
          mode={'multiple'}
          currentIndex={currentIndex}
          reConfirm={reConfirm}
          // setSelectMaterialObj={setSelectMaterialObj}
          // reloadProductList={reload}
        ></ComfirmModal>
      )}
    </div>
  )
}
